import React, { useState, useEffect } from "react";

const Certificate = (props) => {
    return (
        <>
            <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                style={{ border: false ? '1px solid #CCC' : '0px solid', backgroundColor: false ? '#404F93':``, backgroundColor: false ? '#404F93':'#FFF' }}>
                <tr>
                    <td>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" width="755"
                            style={{ background: 'white', margin: '20px' }}>
                            <tr style={{visibility: 'hidden'}}>
                                <td align="center" className="font" colspan="2"
                                    style={{ background: `linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 3%,rgba(255,255,255,1) 4%,rgba(255,255,255,1) 96%,rgba(255,255,255,0) 97%,rgba(255,255,255,0) 100%)` }}>
                                    <img src={require('../../../assets/certi_logo.png')}
                                        width="20%" style={{ marginTop: '45px' }} />
                                </td>
                            </tr>
                            <tr style={{visibility: 'hidden'}}>
                                <td colspan="2"
                                    style={{ color: '#404F93', padding: '30px 50px 30px', textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Montserrat', fontSize: '46px' }}>
                                    <span style={{ color: '#E72C2D', fontSize: '68px' }}>CERTIFICATE</span><br />OF ACHIEVEMENT
                                </td>
                            </tr>
                            <tr style={{visibility: 'visible'}}>
                                <td
                                    style={{ color: '#404F93', lineHeight: '1.4', textAlign: 'justify', padding: '36px 60px 75px', lineHeight: '2', fontWeight: '500', fontFamily: 'Montserrat', fontSize: '20px' }}>
                                    <div style={{ display: 'inline-block' }}>
                                        <div style={{ display: 'inline-block' }}>This certifes that</div>
                                        <div
                                            style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '50%', textAlign: 'center' }}>
                                            {props.name}</div>
                                        &nbsp;of Class&nbsp;
                                        <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block',width: '85%',textAlign: 'center',lineHeight: '1.8'  }}>{props.class}
                                        </div> School&nbsp;
                                        <div
                                            style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block', width: '95%', textAlign: 'center', lineHeight: '1.8' }}>
                                            {props.institute}</div><br />
                                        has scored&nbsp;
                                        <div style={{ borderBottom: '1px solid #404F96', fontWeight: '600', display: 'inline-block' }}>
                                            {props.grade}</div> in the Vocablab English Assessment held on {props.date}.
                                    </div>
                                </td>
                            </tr>
                            <tr
                                style={{ backgroundImage: `url('/logoback.png')`, backgroundSize: '110%', backgroundRepeat: 'no-repeat',visibility: 'hidden' }}>
                                <td style={{ padding: '120px 0px 0px 0px' }}>
                                    <table width="100%" style={{ textAlign: 'center' }}>
                                        <tr>
                                            <td width="100%" style={{ padding: '50px', position: 'relative', textAlign: '-webkit-center' }}>
                                                <table>
                                                    <tr>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', fontWeight: 'bolder', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '22px', borderBottom: '1px solid #404F96', width: '180%', textAlign: 'center', paddingTop: '25px' }}>
                                                            <img src={require('../../../assets/signature.png')} width="40%" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '16px', textAlign: 'center' }}>
                                                            <b>Mr. Jasvinder Singh</b><br />
                                                            <b>CEO</b><br />
                                                            www.wordsworthelt.com
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                            {/* <td width="50%" style={{ padding: '50px', position: 'relative', textAlign: '-webkit-right' }}>
                                                <table width="100%">
                                                    <tr>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', fontWeight: 'bolder', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '22px', borderBottom: '1px solid #404F96', width: '150%', textAlign: 'center' }}>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2"
                                                            style={{ color: '#404F93', lineHeight: '1.4', fontFamily: 'Montserrat', fontSize: '16px', textAlign: 'center' }}>
                                                            <b>Principal</b>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td> */}
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </>
    );
};
export default Certificate;
